var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "a-select",
        {
          staticStyle: { width: "100%" },
          attrs: { value: _vm.currentValue },
          on: { change: _vm.handleChange },
        },
        [
          _c("a-select-option", { attrs: { value: "" } }, [_vm._v("本店")]),
          _vm._l(_vm.stores, function (item) {
            return _c(
              "a-select-option",
              { key: item.tenantId, attrs: { value: String(item.tenantId) } },
              [_vm._v(_vm._s(item.name))]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }